import * as React from 'react';

import { STATE } from 'app/constants';
import { PromptProps, withPrompt } from 'app/components';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';

import { ListWrapper } from './common/list-wrapper';
import { TextImport } from './common/text-import';
import { CodeDescriptionRenderer } from './code/components/code-description-renderer';
import { CodeDescriptionValidationErrors } from './code/components/code-description-validation-errors';
import { actionCreators } from './code/actions';
import { textConfigurationTranslation } from '../constants';
import { TextConfigurationState } from '../types-store';
import { PromptConfirmation } from 'ui';
import { blockAccessTranslation, ListType } from 'app/area/text-configuration/list/constants';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type CodeDescriptionListProps = DefaultContainerProps
  & PromptProps
  & TextConfigurationState
  & typeof actionCreators;

export interface CodeDescriptionListState {
  cancelChanges: boolean;
}

class CodeDescriptionListComponent extends React.PureComponent<CodeDescriptionListProps, CodeDescriptionListState> {
  public static statePath: string = STATE.textConfiguration;

  public state: CodeDescriptionListState = {
    cancelChanges: false
  };

  public componentDidMount() {
    scrollToTop();
    if (this.props.listCodeDescription.metadata === undefined) {
      this.props.getMetadata();
    }
  }

  public componentWillUnmount() {
    this.props.clearList();
  }

  private cancelChanges = () => {
    this.setState({ cancelChanges: !this.state.cancelChanges });
  }

  private continueCancelChanges = () => {
    this.props.cancelChanges();
    this.cancelChanges();
  }

  private renderTextImport() {
    return this.props.listCodeDescription?.showExcelImport
      ? <TextImport
        fetching={this.props.listCodeDescription?.importExcelFetching}
        onClose={this.props.closeExcelImport}
        onDone={this.props.saveImport}
        clearImportValidationErrors={this.props.clearImportValidationErrors}
        translation={this.props.translation}>
        <CodeDescriptionValidationErrors
          validationErrors={this.props.listCodeDescription?.importValidationErrors}
          translation={this.props.translation}
        />
      </TextImport>
      : null;
  }

  public render() {

    const { listCodeDescription,
      displayError,
      loadTextsList, modifyText, saveChanges,
      openExcelImport, exportToExcel,
      continue: onContinue, cancel, shouldDisplayModal,
      sharedState, translation } = this.props;

    return <ListWrapper
      displayError={displayError}
      onContinue={onContinue}
      onCancel={cancel}
      shouldDisplayModal={shouldDisplayModal}
      sharedState={sharedState}
      translation={translation}
      blockAccessTranslation={blockAccessTranslation(ListType.code, translation).text}>
      <CodeDescriptionRenderer
        listState={listCodeDescription}
        loadTextsList={loadTextsList}
        modifyText={modifyText}
        cancelChanges={this.cancelChanges}
        saveChanges={saveChanges}
        translation={translation}
        exportToExcel={exportToExcel}
        openExcelImport={openExcelImport}
        language={sharedState.language}
      />
      {this.renderTextImport()}
      {this.state.cancelChanges
        ? <PromptConfirmation
          title={translation.cancel_changes}
          description={translation.are_you_sure}
          continueText={translation.undo_all}
          cancelText={translation.go_back}
          onContinue={this.continueCancelChanges}
          onCancel={this.cancelChanges}
        />
        : ''}
    </ListWrapper>;
  }
}

const selectors = {
  shouldPrompt: ({ listCodeDescription }: CodeDescriptionListProps, _) =>
    (listCodeDescription.modifiedItems || []).some(code => !code.onlyWhitespace)
};

const container = containerFactory(withPrompt(CodeDescriptionListComponent), actionCreators, selectors, textConfigurationTranslation);

export { container as CodeDescriptionList };
